
export default {
  inject: {
    chat_mode: {
      from: 'di_chat_mode',
      default: 'deep'
    }
  },
  data() {
    return {
      popover_disabled: false
    }
  },
  computed: {
    deep: {
      get(){
        return this.chat_mode === 'deep'
      },
      set(val){
        this.chat_mode = val ? 'deep' : 'fast'
      }
    }
  },
  methods: {
    onChange() {
      this.deep = !this.deep
      this.popover_disabled = true
    }
  }
}
